import axios, { AxiosError } from 'axios'

interface HttpRequestError extends Error {
    additionValue: any
}
export const baseHttpRequest = (baseURL?: string) => {
    const axiosInstance = axios.create({
        baseURL,
        timeout: 120000,
    })
    axiosInstance.defaults.headers['Content-Type'] = 'application/json'
    axiosInstance.interceptors.response.use(
        (response) => {
            // Do something with response data
            return response
        },
        (error: AxiosError) => {
            // Do something with request error
            return Promise.reject<HttpRequestError>({
                status: error.response?.status,
                statusText: error.response?.statusText,
                message:
                    error.response?.data?.message ||
                    error.cause ||
                    error.response?.statusText,
                additionValue: error.response?.data?.additionValue,
            })
        },
    )
    return axiosInstance
}
